import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryOutputDetailModel } from 'src/app/models/inventory/inventory-output-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesRemissionFromOrderService {

  constructor(private _httpClient: HttpClient) { }

  createMassiveOrder(inventoryOutputDetails: InventoryOutputDetailModel[], inventoryOutputId: number): Observable<boolean> {
    const params = new HttpParams().set('inventoryOutputId', inventoryOutputId);
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionFromOrder.CreateMassiveOrderAsync}`,
      inventoryOutputDetails, { params: params }
    );
  }

  getArticlesByOrderForSelection(inventoryOutputId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('inventoryOutputId', inventoryOutputId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionFromOrder.GetArticlesByOrderForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForArticleByOrder(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionFromOrder.GetColumnsForArticleByOrderAsync}`);
  }

  getColumnsForMassiveOrderDetail(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionFromOrder.GetColumnsForMassiveOrderDetailSelectionAsync}`);
  }

  getColumnsForStoreStockByArticle(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionFromOrder.GetColumnsForStoreStockByArticleAsync}`);
  }

  getMassiveOrderDetail(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], inventoryOutputId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('inventoryOutputId', inventoryOutputId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionFromOrder.GetMassiveOrderDetailForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getStoreStockByArticleForSelection(inventoryOutputId: number, articleId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('inventoryOutputId', inventoryOutputId).set('articleId', articleId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionFromOrder.GetStoreStockByArticleForSelectionAsync}`,
      filters, { params: params }
    );
  }
}
